import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {PrinterProjectionDto} from "../../api/sts";

export interface StsPrinterItem {
    label: string
    id: string
}

const systemApi = api.sts.api

function createOption(printer: PrinterProjectionDto): StsPrinterItem {
    return {
        label: `${printer.displayName} (${printer.name})`,
        id: printer.printerId
    };
}

class StsPrinterStore {
    get options(): StsPrinterItem[] {
        return this._options;
    }

    private set options(value: StsPrinterItem[]) {
        this._options = value;
    }

    get loaded(): PrinterProjectionDto[] {
        return this._loaded;
    }

    set loaded(value: PrinterProjectionDto[]) {
        this._loaded = value;
    }

    get data(): PrinterProjectionDto[] {
        return this._data;
    }

    set data(value: PrinterProjectionDto[]) {
        this._data = value;
        this.options = this.buildOptions(value)
    }

    private _data: PrinterProjectionDto[] = [];
    private _loaded: PrinterProjectionDto[] = [];
    private _options: StsPrinterItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const result = await catchApi(async () => await systemApi.findZebraPrinters({
        }))
        this.data = result?.data || []
        this.loaded = this.data
    }

    async search(query?: string) {
        const result = await catchApi(async () => await systemApi.findZebraPrinters({
            query
        }))
        return (result?.data || []).map(e => createOption(e))
    }

    reset() {
        this.data = this.loaded
    }

    private buildOptions(data: PrinterProjectionDto[]): StsPrinterItem[] {
        return data.map(e => createOption(e))
    }
}

const stsZebraPrinterStore = new StsPrinterStore()

export {
    stsZebraPrinterStore
}
